module.exports = __webpack_public_path__ + "assets/img/gd1.0d7628b5.jpg";